import { createApp, defineAsyncComponent,h } from 'vue'
import store from './store'
import App from './app';

import './scss/index.scss'

class Main {
	constructor() {
		// make sure elements (and thus hooks in the page are rendered);
		this.htmlReady(() => {
			//load your component(s) async
			this.setup(`#${process.env.VUE_APP_ID_ATTRIBUTE}`);
		})
	}

	setup(sel) {
		if (!sel) {
			console.log(sel, ' is not found');
			return;
		}

		this.setLoader(sel);

		store.dispatch('loadData').then(() => {
			this.createComponent(`${sel}`, App, store.state.data.paragraaf[0]);
			this.setCustomStyling(store.state.data.styling);
		})
	}

	loadComponent(name) {
		let formattedName = name.split('.')[1]; 
		return defineAsyncComponent(() => import(`./paragrafen/${formattedName}/index.vue`));
	}

	createComponent(sel, comp, props = {}) { 
		if(!sel) return;

		const app = createApp({
			render: () => h(comp, { props })
		});
		app.use(store);
		app.mount(sel);
	}

	setLoader(sel) {
		let el = document.querySelector(sel)

		if (el) {
			let div = document.createElement('div')
			div.classList.add('knd-loader')
			el.append(div)
		}
	}

	setCustomStyling(str) {
		if(str) {
			var css = str.replace(/\n|\r/g, "");
			this.injectCSS(css);
		}
	}

	injectCSS(css) {
		let el = document.createElement('style');
		el.type = 'text/css';
		el.innerText = css;
		document.head.appendChild(el);
		return el;
	};

	htmlReady(cb) {
		// in case the document is already rendered
		if (document.readyState !== 'loading') {
			cb()
		}

		// modern browsers
		else if (document.addEventListener) {
			document.addEventListener('DOMContentLoaded', cb)
		}
		// IE <= 8
		else
			document.attachEvent('onreadystatechange', () => {
				if (document.readyState == 'complete') cb()
			})
	}
}

let main = new Main()
